import { dynamicpolygon, customRouteList, airmennoticelist, listbyposition, airlineDataList, getAllAirspaceData } from "../../request/api";
const state = {
    showDetail: false,
    planInfo: {},
    showDraw: false,
    dynamicpolygonList: [],
    customRouteList: [],
    airmennoticelist: [],
    airPortListData: [],
    commomAirportList: [],
    transportAirportList: [],
    airlineDataList: [],
    showAlter: '',
    showAirportAlter: '',
    showAirportInfoAlter: '',
    airportId: '',
    totalCount: null,
    linePage: 1,
    spacePage: 1,
    infoDetail: '',
    isShow: false,
    addCustomIsShow: false,
    warnAirportList: [],
    airspaceSqIsShow: false,
    customLineIsShow: false,
    airlineDataIsShow: false,
    commonairportIsShow: false,
};
const mutations = {
    changeCommonairportIsShow(state, bool) {
        state.commonairportIsShow = bool
    },
    changeAirlineDataIsShow(state, bool) {
        state.airlineDataIsShow = bool
    },
    changeAirspaceSqIsShow(state, bool) {
        state.airspaceSqIsShow = bool
    },
    changeCustomLineIsShow(state, bool) {
        state.customLineIsShow = bool
    },
    changeShowDraw(state, bool) {
        state.showDraw = bool;
    },
    // changeDynamicpolygonList(state, page) {
    //     state.dynamicpolygonList = page.list;
    //     state.totalCount = page.totalCount;
    // },
    changeDynamicpolygonList(state, arr) {
        console.log(arr);
        state.dynamicpolygonList = arr;
    },
    changecustomRouteList(state, page) {
        state.customRouteList = page.list;
        state.totalCount = page.totalCount;
    },
    changeairmennoticelist(state, page) {
        state.airmennoticelist = page.list;
        state.totalCount = page.totalCount;
    },
    changeAirlineDataList(state, page) {
        state.airlineDataList = page.list
        state.totalCount = page.totalCount;
    },
    changeWarnAirportList(state, page) {
        state.warnAirportList = page.list;
        state.totalCount = page.totalCount;
    },
    changeshowAlter(state, type) {
        state.showAlter = type;
    },
    changeshowAlter(state, type) {
        state.showAlter = type;
    },
    changeshowAirportAlter(state, type) {
        state.showAirportAlter = type;
    },
    changeshowAirportInfoAlter(state, type) {
        state.showAirportInfoAlter = type;
    },
    changeAirPortList(state, list) {
        console.log(list);
        let commomlist = []
        let transporlist = []
        for (var i = 0; i < list.length; i++) {
            //    console.log( list[i].airporttype);
            if (list[i].airporttype == "2") {
                // transporlist.push(list[i])
                transporlist.push(list[i])
            } else {
                commomlist.push(list[i])
                    // state.transportAirportList
            }
        }
        //     // airporttype 1 com   2trans

        state.commomAirportList = commomlist;
        state.transportAirportList = transporlist;
        console.log(commomlist, transporlist, "---------------state.commomAirportList:", state.commomAirportList, "state.transportAirportList:", state.transportAirportList);
    },
    changeAirportId(state, id) {
        state.airportId = id;
    },
    changeShowDetail(state, bool) {
        state.showDetail = bool;
    },
    changePlanInfo(state, info) {
        state.planInfo = info;
    },
    changelinePage(state, info) {
        state.linePage = info;
    },
    changespacePage(state, info) {
        state.spacePage = info;
    },
    changeinfoDetail(state, info) {
        state.infoDetail = info;
    },
    changeIsShow(state, bool) {
        state.isShow = bool;
    },
    changeAddCustomIsShow(state, bool) {
        state.addCustomIsShow = bool
    }
};
const actions = {
    async dynamicpolygonListAction(context) {
        let res1 = await getAllAirspaceData();
        let arr = [];
        res1.forEach((e) => {
            if (e.status === 2) {
                arr.push(e);
            }
        });
        res1.forEach((e) => {
            if (e.status === 1) {
                arr.push(e);
            }
        });
        res1.forEach((e) => {
            if (e.status === 0) {
                arr.push(e);
            }
        });

        // let res = await dynamicpolygon({ page: context.getters.spacePage, "limit": 10 });
        // context.commit('changeDynamicpolygonList', res.page);
        context.commit('changeDynamicpolygonList', arr);
    },
    async customRouteListAction(context) {
        let res = await customRouteList({ page: context.getters.linePage, "limit": 10 });
        context.commit('changecustomRouteList', res.page);
    },
    async AirmennoticelistAction(context, page) {
        let res = await airmennoticelist({ page, "limit": 10 });
        console.log(res);
        context.commit('changeairmennoticelist', res.page);
    },
    // async getWarnAirportListAction(context, page) {
    //     let res = await warnAirportList({ page, "limit": 10 });
    //     console.log(res);
    //     context.commit('changeWarnAirportList', res.page);
    // },
    // 航司资料列表
    async AirlineDatalistAction(context, page) {
        let res = await airlineDataList({ page, "limit": 10 });
        console.log(res);
        context.commit('changeAirlineDataList', res.page);
    },
    async getAirPortListAction(context) {

        let res = await listbyposition({ province: "湖南", });

        context.commit('changeAirPortList', res);
    }
};

const getters = {
    airspaceSqIsShow(state) {
        return state.airspaceSqIsShow
    },
    customLineIsShow(state) {
        return state.customLineIsShow
    },
    showDraw(state) {
        return state.showDraw;
    },
    dynamicpolygonList(state) {
        return state.dynamicpolygonList;
    },
    customRouteList(state) {
        return state.customRouteList;
    },
    airmennoticelist(state) {
        return state.airmennoticelist;
    },
    // airlineDataList(state){
    //     return state.airlineDataList
    // },
    warnAirportList(state) {
        return state.warnAirportList;
    },
    showAlter(state) {
        return state.showAlter;
    },
    airPortListData(state) {
        return state.airPortListData;
    },
    showAirportAlter(state) {
        return state.showAirportAlter;
    },
    showAirportInfoAlter(state) {
        return state.showAirportInfoAlter;
    },
    airportId(state) {
        return state.airportId
    },
    showDetail(state) {
        return state.showDetail
    },
    planInfo(state) {
        return state.planInfo
    },
    totalCount(state) {
        return state.totalCount
    },
    linePage(state) {
        return state.linePage
    },
    spacePage(state) {
        return state.spacePage
    },
    infoDetail(state) {
        return state.infoDetail
    },
    addWarnAirspaceIsShow(state) {
        return state.isShow
    },
    addCustomIsShow(state) {
        return state.addCustomIsShow
    },
    airlineDataIsShow(state) {
        return state.airlineDataIsShow
    },
    transportAirportList(state) {
        return state.transportAirportList
    },
    commomAirportList(state) {
        return state.commomAirportList
    },
    commonairportIsShow(state) {
        return state.commonairportIsShow
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}